export const formatColorCode = (code, type) => {
  let codeToFormat = "";
  if (code.substring(code.length - 2) === ` ${type}`) {
    //is already in form '907 C'
    codeToFormat = code;
  } else if (code.substring(code.length - 1) === type) {
    //is in form '907C'
    codeToFormat = code.substring(0, code.length - 1) + ` ${type}`;
  } else {
    //is in form '907'
    codeToFormat = code + ` ${type}`;
  }

  return formatCode(codeToFormat);
};

//helper function for use in other functions
const formatCode = (code) => {
  const parts = code.split(" ");
  let newCode = "";
  if (parts[0].length < 3) {
    //code with format like RR U
    newCode = parts[0].toUpperCase() + " ";
    for (let i = 1; i < parts.length; i++) {
      newCode +=
        parts[i].substring(0, 1).toUpperCase() +
        parts[i].substring(1).toLowerCase() +
        " ";
    }
    return newCode.trimEnd();
  } else if (
    parts[0].substring(parts[0].length - 1).toLowerCase() !==
      parts[0].substring(parts[0].length - 1).toUpperCase() &&
    Number.isInteger(
      Number(parts[0].substring(parts[0].length - 2, parts[0].length - 1))
    )
  ) {
    //code with format like 755I U
    for (let i = 0; i < parts.length; i++) {
      newCode += parts[i].toUpperCase() + " ";
    }
    return newCode.trimEnd();
  } else {
    for (let i = 0; i < parts.length; i++) {
      if (Number.isInteger(Number(parts[i].substring(parts[i].length - 1)))) {
        newCode += parts[i].toUpperCase() + " ";
      } else {
        newCode +=
          parts[i].substring(0, 1).toUpperCase() +
          parts[i].substring(1).toLowerCase() +
          " ";
      }
    }
    return newCode.trimEnd();
  }
};
